//import { UserRole } from "../constants";

const normalizeSex = (sexValue) => {
  if (!sexValue) return "M"; // Valor por defecto
  
  const lowerValue = String(sexValue).trim().toLowerCase();
  
  // Mapeo de valores posibles
  const sexMap = {
    'm': 'M',
    'f': 'F',
    'masculino': 'M',
    'femenino': 'F',
    'male': 'M',
    'female': 'F'
  };
  
  return sexMap[lowerValue] || "M"; // Devuelve "M" si no encuentra coincidencia
};

export const formatDate = (dateString) => {
  try {
    // Si ya está en formato ISO
    if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString;
    }
    // Si está en formato DD/MM/YYYY
    if (typeof dateString === 'string' && dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    // Si es un número (representa días desde 1900-01-01)
    if (typeof dateString === 'number') {
      const date = new Date((dateString - 25569) * 86400 * 1000); // Convertir días a milisegundos
      return date.toISOString().split('T')[0];
    }
    // Intento genérico con el constructor Date
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }
  } catch {
    return "1900-01-01";
  }
};

export const processSingleCase = (item, formatDateFn) => {
  //const role = localStorage.getItem("role");
  //console.log("Current role in processSingleCase:", role); // Para debug
  let phone = item['TELEFONO']?.toString().replace(/\D/g, "") || "";
  if (phone.startsWith("0")) {
    phone = phone.slice(1);
  }
  if (!phone.startsWith("58")) {
    phone = "58" + phone;
  }

  let optionalPhone = item['TELEFONO_ALTERNO']?.toString().replace(/\D/g, "") || "";
  if (optionalPhone.startsWith("0")) {
    optionalPhone = optionalPhone.slice(1);
  }
  if (optionalPhone && !optionalPhone.startsWith("58")) {
    optionalPhone = "58" + optionalPhone;
  }

  let birthDate = formatDateFn(item['FECHA_NACIMIENTO']);

  let requirements = [];
  if (item['REQUERIMIENTOS']) {
    if (Array.isArray(item['REQUERIMIENTOS'])) {
      requirements = item['REQUERIMIENTOS'];
    } else if (typeof item['REQUERIMIENTOS'] === 'string') {
      requirements = item['REQUERIMIENTOS'].split('\\').map(req => req.trim());
    }
  }

    // Función para normalizar el valor de SEXO
  

  return {
    holder: {
      ci: (() => {
        const raw = item['CI_TITULAR']?.toString() || '';
        const digitsOnly = raw.replace(/\D/g, "");
        if (digitsOnly.length >= 5 && digitsOnly.length <= 8) {
          return 'V' + digitsOnly;
        } else {
          return "";
        }
      })(),
      name: item['NOMBRE_TITULAR'] || "",
      phone: phone,
      optional_phone: optionalPhone,
      birthdate: birthDate,
      sex: normalizeSex(item['SEXO']),
      condition: item['Activo'],
      subsidiary: item['FILIAL'] || "",
      is_holder: true,
    },
    patient: {
      ci: item['CI_PACIENTE'] || "",
      name: item['NOMBRE_PACIENTE'] || "",
      birthdate: birthDate,
      sex:normalizeSex(item['SEXO']),
      phone: phone,
      optional_phone: optionalPhone,
      subsidiary: item['FILIAL'] || "",
      is_holder: false,
      is_minor: false,
      //is_minor: (item['ES_MENOR'] || '').toUpperCase() === 'SI' // Default false, solo true si es "SI"
    },
    diagnosis: item['DIAGNOSTICO'] ?
      (Array.isArray(item['DIAGNOSTICO']) ?
        item['DIAGNOSTICO'] :
        typeof item['DIAGNOSTICO'] === 'string' ?
          item['DIAGNOSTICO'].split('\\').map(d => d.trim()) :
          [item['DIAGNOSTICO']]
      ) : [],
    medical_center: item['CLINICA'] || "",
    status: "pendiente",
    subsidiary: item['FILIAL'] || "",
    requirements: requirements.map(req => ({ requirement: req })),
    duplicate: false
    // En processSingleCase(), agregar esto al objeto de retorno:
    //is_minor: (rawData.ES_MENOR || '').toUpperCase() === 'SI' // Default false, solo true si es "SI"
    
  };
};

export const processExcelData = (data, formatDateFn) => {
  //const role = localStorage.getItem("role");
  //console.log("Current role in processSingleCase:", role); // Para debug
  return data.map(item => {
    // Formatear teléfonos
    let phone = item['TELEFONO']?.toString().replace(/\D/g, "") || "";
    if (phone.startsWith("0")) {
      phone = phone.slice(1);
    }
    if (!phone.startsWith("58")) {
      phone = "58" + phone;
    }

    let optionalPhone = item['TELEFONO_ALTERNO']?.toString().replace(/\D/g, "") || "";
    if (optionalPhone.startsWith("0")) {
      optionalPhone = optionalPhone.slice(1);
    }
    if (optionalPhone && !optionalPhone.startsWith("58")) {
      optionalPhone = "58" + optionalPhone;
    }

    // Formatear fecha correctamente
    let birthDate = formatDateFn(item['FECHA_NACIMIENTO']);

    // Formatear requerimientos
    let requirements = [];
    if (item['REQUERIMIENTOS']) {
      if (Array.isArray(item['REQUERIMIENTOS'])) {
        requirements = item['REQUERIMIENTOS'];
      } else if (typeof item['REQUERIMIENTOS'] === 'string') {
        requirements = item['REQUERIMIENTOS'].split('\\').map(req => req.trim());
      }
    }

    

    return {
      rawData: { ...item }, // Guardamos los datos originales para edición
      processedData: {
        holder: {
          ci: item['CI_TITULAR'] ? 'V' + item['CI_TITULAR'].toString().replace(/\D/g, "") : "",
          name: item['NOMBRE_TITULAR'] || "",
          phone: phone,
          optional_phone: optionalPhone,
          birthdate: birthDate,
          sex: normalizeSex(item['SEXO']),
          condition: item['CONDICION']?.toLowerCase() || "titular",
          subsidiary: item['FILIAL'] || "",
          is_holder: true,
        },
        patient: {
          ci: item['CI_PACIENTE'] ? 'V' + item['CI_PACIENTE'].toString().replace(/\D/g, "") : "",
          name: item['NOMBRE_PACIENTE'] || item['NOMBRE_BENEFICIARIO'] || "",
          birthdate: birthDate,
          sex: normalizeSex(item['SEXO']),
          phone: phone,
          optional_phone: optionalPhone,
          subsidiary: item['FILIAL'] || "",
          is_holder: false,
          is_minor: false,
        },
        diagnosis: item['DIAGNOSTICO'] ?
          (Array.isArray(item['DIAGNOSTICO']) ?
            item['DIAGNOSTICO'] :
            typeof item['DIAGNOSTICO'] === 'string' ?
              item['DIAGNOSTICO'].split('\\').map(d => d.trim()) :
              [item['DIAGNOSTICO']]
          ) : [],
        medical_center: item['CLINICA'] || "",
        status: "pendiente",
        subsidiary: item['FILIAL'] || "",
        requirements: requirements.map(req => ({ requirement: req })),
        duplicate: false,
      }
    };
  });
};